import { render, staticRenderFns } from "./ContentChanges.vue?vue&type=template&id=54a5c5c4&"
import script from "./ContentChanges.vue?vue&type=script&lang=ts&"
export * from "./ContentChanges.vue?vue&type=script&lang=ts&"
import style0 from "./ContentChanges.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports